import { request } from '../request/index';
import { handleParams, objToString, xposParamsMap } from '@didi/webx-js-core';
import { getNineChapterWebxParams, getRuntimeStandardArgument } from '../statistic';
import { getSessionParams } from '../webx';
import { getOmega } from '../omega';
import { utils } from '../utils';
import { alimpCommonJump, alipayCommonJump, cowxmpCommonJump, driverCommonJump, drwxmpCommonJump, gjwxmpCommonJump, h5CommonJump, kfalimpCommonJump, kfdriverCommonJump, kfdwxmpCommonJump, yxwxmpCommonJump, kfpassengerCommonJump, kfwxmpCommonJump, passengerCommonJump, esappCommonJump, qjwxmpCommonJump, thwxmpCommonJump, weixinCommonJump, wxmpCommonJump, dympCommonJump, mqqCommonJump, gaswxmpCommonJump, hitchappCommonJump, sfcwxmpCommonJump, sfcalimpCommonJump, hywxmpCommonJump, hyalimpCommonJump, hydriverCommonJump, crwxmpCommonJump, cralimpCommonJump, eshwxmpCommonJump, hwfastappCommonJump, hypassengerCommonJump } from '../platform/xenv';
const xenvDchnJump = {
    'alimp': alimpCommonJump,
    'alipay': alipayCommonJump,
    // 'bdmp': '',
    'cowxmp': cowxmpCommonJump,
    'sfcwxmp': sfcwxmpCommonJump,
    'sfcalimp': sfcalimpCommonJump,
    'driver': driverCommonJump,
    'drwxmp': drwxmpCommonJump,
    'gjwxmp': gjwxmpCommonJump,
    'h5': h5CommonJump,
    'kfalimp': kfalimpCommonJump,
    'kfdriver': kfdriverCommonJump,
    'kfdwxmp': kfdwxmpCommonJump,
    'kfpassenger': kfpassengerCommonJump,
    'kfwxmp': kfwxmpCommonJump,
    'mqq': mqqCommonJump,
    'passenger': passengerCommonJump,
    'esapp': esappCommonJump,
    'qjwxmp': qjwxmpCommonJump,
    // 'qqmp': '',
    'thwxmp': thwxmpCommonJump,
    'weixin': weixinCommonJump,
    'wxmp': wxmpCommonJump,
    'dymp': dympCommonJump,
    'yxwxmp': yxwxmpCommonJump,
    'gaswxmp': gaswxmpCommonJump,
    'hitchapp': hitchappCommonJump,
    'hywxmp': hywxmpCommonJump,
    'hyalimp': hyalimpCommonJump,
    'hydriver': hydriverCommonJump,
    'crwxmp': crwxmpCommonJump,
    'cralimp': cralimpCommonJump,
    'eshwxmp': eshwxmpCommonJump,
    'hwfastapp': hwfastappCommonJump,
    'hypassenger': hypassengerCommonJump
};
let xenv = ''; // 当前xenv
let reqXenv = ''; // 请求入参的xenv
let apiEnv = ''; // cover/config 接口环境默认线上
let reqDchn = '';
let passThrough = '';
let xspmInfo = {};
let xposInfo = {};
let dchnJump;
// 参数处理获取全局变量
function dealParams(loadParams, env, api, params) {
    xenv = env;
    apiEnv = api;
    reqXenv = (loadParams.extParams && loadParams.extParams.xenv) || xenv;
    xspmInfo = (loadParams.extParams && loadParams.extParams.xspmInfo) || {};
    xposInfo = (loadParams.extParams && loadParams.extParams.resourceInfo) || {};
    let { dchn, url, scene } = loadParams;
    if (dchn || scene) {
        reqDchn = dchn || scene;
        passThrough = objToString(params);
        return;
    }
    if (url) {
        // url ---> https://v.didi.cn/p/${dchn}?a=1
        let splitUrl = url.split('/');
        let key = splitUrl[splitUrl.length - 1];
        let query = handleParams(url);
        passThrough = objToString(Object.assign({}, params, query));
        reqDchn = key && key.indexOf('?') ? key.split('?')[0] : key;
    }
}
// 获取跳转配置 cover/config
function coverConfig() {
    const nineChapterParams = getNineChapterWebxParams();
    const params = Object.assign({}, {
        support_bridge: true,
        args: {
            dchn: reqDchn,
            xenv: reqXenv,
            pass_through: passThrough
        }
    }, getSessionParams(), nineChapterParams, { dchn: reqDchn, xenv: reqXenv });
    if (utils.isObj(xspmInfo) && Object.keys(xspmInfo).length > 0 && getOmega()) {
        params['xspm_from'] = getOmega().formatSpmPath ? getOmega().formatSpmPath({ a: nineChapterParams['prod_key'], ...xspmInfo }) : '';
    }
    else {
        delete params['xspm_from'];
    }
    if (utils.isObj(xposInfo) && Object.keys(xposInfo).length > 0) {
        /* 存在合法xpos参数 需要处理xpos相关逻辑 */
        xposInfo = {
            prod_key: params['prod_key'],
            ...xposInfo
        };
        /* xpos参数映射 */
        xposInfo = Object.entries(xposInfo).reduce((res, [key, value]) => {
            if (xposParamsMap[key]) { // 需要映射 进行key转换
                res[xposParamsMap[key]] = value;
            }
            else {
                res[key] = value;
            }
            return res;
        }, {});
        params['xpos_from'] = xposInfo;
        /* 兼容xspm体系和xpos体系 特殊操作 */
        if (!params['xspm_from']) {
            params['xspm_from'] = `xpos_info-${encodeURIComponent(JSON.stringify(params['xpos_from']))}`;
        }
        /* End兼容xspm体系和xpos体系 特殊操作 */
    }
    else {
        delete params['xpos_from'];
    }
    params['std_args'] = getRuntimeStandardArgument();
    return new Promise((resolve, reject) => {
        request('POST', apiEnv + '/webx/chapter/cover/config', {
            data: params
        }).then(res => {
            if (res.errno === 0) {
                console.log('拉取 webx 跳转配置成功');
                resolve(res.data);
            }
            else {
                console.log('coverConfig 响应errno不为0');
                reject(res);
            }
        }, err => {
            console.log('拉取 webx 跳转配置失败---->', err);
            reject(err);
        });
    });
}
// 执行webx 跳转封装一层
function webx(loadParams) {
    return new Promise((resolve, reject) => {
        // 处理跳转配置接口返回的数据
        function handleCoverData(data) {
            let dchnData = {
                url: data.conf.url || data.conf.mp_webview || '',
                appId: data.conf.appid || '',
                originalAppId: '',
                scheme: data.conf.scheme || '',
                path: data.conf.mp_native || '',
                activityId: data.conf.activity_id || '',
                extParams: {
                    source: 'from_webx',
                    injectNineChapterParams: false,
                    moveType: (data.conf && data.conf.common) ? data.conf.common.move_type : 0,
                    h5JumpMethod: (loadParams.extParams && loadParams.extParams.h5JumpMethod) || '',
                    // 统一获取赤兔的配置信息，只有内嵌H5会对这两个参数进行接收与处理
                    needLocation: (data.conf && data.conf.common) ? data.conf.common.need_location : 'none',
                    needLogin: (data.conf && data.conf.common) ? data.conf.common.need_login : 'none'
                }
            };
            /* 适配超级小程序短链 */
            if (data.conf.action && ['wx_scheme', 'alipay_scheme'].includes(data.conf.action)) {
                let action = data.conf.action;
                dchnData['scheme'] = data.conf[action].scheme;
                dchnData.extParams['openPageTarget'] = 'native';
                // 乘客端超小，使用bridge拉起小程序
                if (data.conf.wx_scheme && data.conf.wx_scheme.original_id && data.conf.wx_scheme.pagepath) {
                    dchnData['originalAppId'] = data.conf.wx_scheme.original_id;
                    dchnData['path'] = data.conf.wx_scheme.pagepath;
                }
            }
            /* End 适配超级小程序短链 */
            dchnJump = xenvDchnJump[xenv];
            dchnJump(dchnData, xenv);
            resolve({
                dchn: data.conf.dchn || '',
                mp_webview: data.conf.mp_webview || '',
                url: data.conf.url || '',
                mp_native: data.conf.mp_native || ''
            });
        }
        coverConfig()
            .then(res => {
            handleCoverData(res);
        }).catch(err => {
            reject(err);
        });
    });
}
let DoDchnJumpFn = (loadParams = {}, env, api, params = {}) => {
    dealParams(loadParams, env, api, params);
    return webx(loadParams);
};
export { DoDchnJumpFn as doDchn };
